import { render, staticRenderFns } from "./OwnersAssociationHeader.vue?vue&type=template&id=1a2a3530&"
import script from "./OwnersAssociationHeader.vue?vue&type=script&lang=js&"
export * from "./OwnersAssociationHeader.vue?vue&type=script&lang=js&"
import style0 from "./OwnersAssociationHeader.vue?vue&type=style&index=0&id=1a2a3530&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports